module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "height": "4rem"
    }
  }, [(_vm.attribute.sorteditAble === false) ? _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "60%",
      "color": "#8e8e93"
    }
  }, [_vm._v("选择靶点")]) : _c('div', {
    staticClass: "item-title label",
    staticStyle: {
      "width": "54%"
    }
  }, [_vm._v("\n    选择靶点\n    "), (_vm.attribute.description) ? _c('a', {
    staticClass: "alert-text",
    on: {
      "click": function($event) {
        return _vm.displayMessage(_vm.attribute.description)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".9rem"
    },
    attrs: {
      "src": _vm.questionUrl
    }
  })]) : _vm._e()]), _vm._v(" "), (!_vm.attrValueDisplay) ? _c('div', {
    staticClass: "item-input"
  }, [(_vm.attribute.sorteditAble === false) ? _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.attribute.value
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.value),
      expression: "attribute.value"
    }],
    staticStyle: {
      "font-size": "smaller",
      "margin-left": "0.1rem",
      "height": "1rem"
    },
    attrs: {
      "type": "text",
      "placeholder": "请选择",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.attribute.value)
    },
    on: {
      "click": function($event) {
        return _vm.showOptionList(_vm.attribute)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "value", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "item-input"
  }, _vm._l((_vm.attrValueDisplay), function(arr, index) {
    return _c('div', {
      staticStyle: {
        "font-size": "smaller",
        "margin-left": "0.5rem"
      },
      attrs: {
        "readonly": "readonly"
      },
      on: {
        "click": function($event) {
          return _vm.showOptionList(_vm.attribute)
        }
      }
    }, [_vm._v(_vm._s(arr))])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-076231dd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Cust/TargetChoose.vue
// module id = 1527
// module chunks = 8